import AppRequests from "components/ProjectSpecificComponents/API/AppRequests/AppRequests"
import { TReactSelectOption } from "components/ProjectSpecificComponents/Interfaces/ExternalComponentsInterfaces"

export type TItemOfTypeLevels = {
	itemOfTypeItemId?: string
	picklistFieldId?: string
	projectId: string
	isPicklistFirstSetSecond: boolean
	isOneLevelOnly: boolean
}

export const getIOTLevels = async ({
	itemOfTypeItemId,
	picklistFieldId,
	projectId,
	isPicklistFirstSetSecond,
	isOneLevelOnly,
}: TItemOfTypeLevels) => {
	const params = `itemOfTypeLevels?itemOfTypeItemId=${itemOfTypeItemId}&picklistFieldId=${picklistFieldId}&projectId=${projectId}&isPicklistFirstSetSecond=${isPicklistFirstSetSecond}&isOneLevelOnly=${isOneLevelOnly}`

	const { ok, data } = await AppRequests("Requests").get<TReactSelectOption[]>(undefined, {
		params,
	})

	if (ok && data) {
		return data
	} else {
		return undefined
	}
}

export default getIOTLevels
